import { createSelector, createFeatureSelector } from '@ngrx/store';
import { State } from './my-connections.reducer';

export const selectState = createFeatureSelector<State>('myConnections');
export const selectConnections = createSelector(selectState, (state: State) => state.connections);
